var React = require('react');

function CloseBr (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 1L1 16","stroke":"black","strokeWidth":"1.5047","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1 1L16 16","stroke":"black","strokeWidth":"1.5047","strokeLinejoin":"round","key":1})]);
}

CloseBr.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = CloseBr;

CloseBr.default = CloseBr;
